<div class="card col-sm-10" *ngIf="pastBookings.length > 0">
  <div *ngFor="let booking of pastBookings" class="row past-booking">
    <span class="col-sm-3 item-label">Service:</span>
    <span class="col-sm-9 mb-1">{{ booking.service_name }}</span>
    <span class="col-sm-3 item-label">Date:</span>
    <span class="col-sm-9 mb-1">{{
      booking.datetime.format('Do MMMM YYYY')
    }}</span>
    <span class="col-sm-3 item-label">Time:</span>
    <span class="col-sm-9 mb-1">{{ booking.datetime | date : 'HH:mm' }}</span>
  </div>
</div>

<h2 class="no-bookings" *ngIf="pastBookings.length === 0">
  {{ 'ACCOUNT.NO_PAST_BOOKINGS' | translate }}
</h2>
